import React from "react";
import { connect } from "react-redux";
import { signin } from "../actions/auth";
import { withRouter } from "react-router-dom";
import _ from "lodash";
/*
const validate = values => {
  const errors = {};

  if (!values.email) {
    errors.email = "Please provide an email.";
  }

  if (!values.password) {
    errors.password = "Please provide a password.";
  }

  return errors;
};
*/

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.onInputChange = this.onInputChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onInputChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    this.setState({ ...this.state, [name]: value });
  }

  onSubmit(event) {
    this.props.signIn(this.state);
    event.preventDefault();
  }

  render() {
    const { loginErrors } = this.props;
    var signInError = _.isEmpty(loginErrors)
      ? null
      : <div className="invalid-signin bg-danger"> {loginErrors} </div>;
    return (
      <div className=" container auth-container">
        <div className="col-md-12">
          <div className="clearfix">
            <div className="col-md-3"> </div>
            <div className="col-md-6 box">
              <div className="col-md-12">
                {signInError}
                <div className="title"> Ridge Admin</div>

                <form onSubmit={this.onSubmit} className="clearfix">

                  <div className="form-group col-md-12">
                    <label> Email </label>
                    <input
                      className="form-control"
                      name="email"
                      onChange={this.onInputChange}
                    />
                  </div>

                  <div className="form-group col-md-12">
                    <label> Password </label>
                    <input
                      className="form-control"
                      name="password"
                      type="password"
                      onChange={this.onInputChange}
                    />
                  </div>

                  <div className="col-md-12 form-buttons">
                    <button type="submit" className="btn btn-success btn-block">
                      {" "}Sign In{" "}
                    </button>
                  </div>
                </form>
                <div className="clearfix" />
              </div>
            </div>
            <div className="col-md-3"> </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...state.app
  };
};

const mapDispatchToProps = dispatch => {
  return {
    signIn(credentials) {
      dispatch(signin(credentials));
    }
  };
};

const SignIn = withRouter(connect(mapStateToProps, mapDispatchToProps)(Form));

export default SignIn;



// WEBPACK FOOTER //
// ./src/components/Signin.js